import React, { useEffect } from "react";
import { useGetAIAgents } from "hooks/useGetAIAgents";
import { AgentCard } from "../components/AgentCard/AgentCard";
import { IAgent } from "interfaces/entities/agent.interface";
import { Button, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setDataAction } from "redux/actions/agentsActions";

export const AgentList = () => {
  const { data, isLoading, error } = useGetAIAgents();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setDataAction(data?.rows));
  }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <h1>Агенты</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
        <Card>
          <div className="flex justify-center items-center w-full h-full">
            <div className="flex justify-center items-center">
              <Button
                variant="text"
                color="primary"
                onClick={() => navigate("/admin/ai-agents/add")}
              >
                Создать агента <FaPlus className="ml-4" />
              </Button>
            </div>
          </div>
        </Card>
        {data.rows.map((agent: IAgent) => (
          <AgentCard key={agent.id} agent={agent} />
        ))}
      </div>
    </div>
  );
};
